import React, { FC } from 'react'
import {
  Box,
  Checkbox,
  FormControlLabel,
  Stack,
  Typography,
} from '@mui/material'
import { CheckpointItem } from '@/apps/legacy/features/guidance/types/guidanceCheckPoints'
import { CHECKPOINT_STYLES } from '../../../constants/styles/checkpoint'

interface CheckpointCardProps {
  checkpoints: CheckpointItem[]
  selectedIds: string[]
  onSelectionChange?: (selectedIds: string[]) => void
}

export const CheckpointCard: FC<CheckpointCardProps> = ({
  checkpoints,
  selectedIds = [],
  onSelectionChange,
}) => {
  const handleCheckboxChange =
    (id: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
      if (!onSelectionChange) return

      const newSelectedIds = event.target.checked
        ? [...selectedIds, id]
        : selectedIds.filter((selectedId) => selectedId !== id)

      onSelectionChange(newSelectedIds)
    }

  return (
    <Box>
      <Stack spacing={CHECKPOINT_STYLES.CHECKPOINT_SPACING}>
        {checkpoints.map((item) => (
          <Box
            key={item.id}
            sx={{
              borderLeft: `${CHECKPOINT_STYLES.CARD_BORDER_WIDTH} solid ${CHECKPOINT_STYLES.CARD_BORDER_COLOR}`,
              pl: CHECKPOINT_STYLES.CARD_PADDING_LEFT,
              py: CHECKPOINT_STYLES.CARD_PADDING_VERTICAL,
            }}
          >
            <Stack spacing={0.25}>
              <Typography
                variant="subtitle2"
                sx={{
                  color: CHECKPOINT_STYLES.LABEL_COLOR,
                  fontSize: CHECKPOINT_STYLES.LABEL_FONT_SIZE,
                  fontWeight: CHECKPOINT_STYLES.LABEL_FONT_WEIGHT,
                  mb: CHECKPOINT_STYLES.LABEL_MARGIN_BOTTOM,
                }}
              >
                {item.label}
              </Typography>
              {item.points.map((point, index) => (
                <Typography
                  key={index}
                  variant="body2"
                  sx={{
                    color: CHECKPOINT_STYLES.POINT_COLOR,
                    fontSize: CHECKPOINT_STYLES.POINT_FONT_SIZE,
                    lineHeight: CHECKPOINT_STYLES.POINT_LINE_HEIGHT,
                    pl: CHECKPOINT_STYLES.POINTS_PADDING_LEFT,
                  }}
                >
                  {point}
                </Typography>
              ))}
              <FormControlLabel
                control={
                  <Checkbox
                    checked={selectedIds.includes(item.id)}
                    onChange={handleCheckboxChange(item.id)}
                    sx={{
                      color: CHECKPOINT_STYLES.CHECKBOX_COLOR,
                      '&.Mui-checked': {
                        color: CHECKPOINT_STYLES.CHECKBOX_CHECKED_COLOR,
                      },
                    }}
                  />
                }
                label={
                  <Typography
                    variant="caption"
                    sx={{
                      color: CHECKPOINT_STYLES.GUIDANCE_LABEL_COLOR,
                      fontSize: CHECKPOINT_STYLES.GUIDANCE_LABEL_FONT_SIZE,
                    }}
                  >
                    [指導支援に加味]
                  </Typography>
                }
                sx={{
                  mt: CHECKPOINT_STYLES.CHECKBOX_MARGIN_TOP,
                  ml: 0,
                  alignItems: 'center',
                }}
              />
            </Stack>
          </Box>
        ))}
      </Stack>
    </Box>
  )
}
